// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Buuz","productName":"Table_productName__3J_S0"};